import BaseLayout from '@/components/BaseLayout.vue'
import api from '@/services/api';

export default {
    name: 'educationVideo',

    data() {
        return {
            video: {},
        };
    },

    components: {
        BaseLayout
    },

    
    methods: {
        /**
         * Gets the education video from API
         */
        getVideo() {
            api.get(`/api/promotions_active_education_videos/${this.$route.params.id}`)
                .then((response) => {
                    this.video = response.data.body.video;
                });
        },

        /**
         * Handles the video playing event
         */
        playing () {
            api.post(`/api/promotions_education_video_watch_start/${this.$route.params.id}`)
                .then(() => {
                    this.getVideo()
                });
        },

            
        /**
         * Handles the video ended event
         */
        ended () {
            api.post(`/api/promotions_education_video_watch_complete/${this.$route.params.id}`)
            .then(() => {
                this.getVideo()
            });

        }
    },

    mounted() {
        this.getVideo();
    },
}